import Dropdown from "@/components/common/Dropdown";
import CharityDropdown from "@/components/CharityComp/CharityDropDown";
import Link from "next/link";
import styles from "./CharityChange.module.scss";
import { useSelector } from "react-redux";
export default function CharityChangeComp({ popupCloseHandler }) {
  const show_charity_active_msg = useSelector((state) => state.general.show_charity_active_message);
    let impactData = [
        'Charity Name',
        'Charity Name',
        'Charity Name'
      ];
      let disabled = [];
      let dropdownTitle = 'Change your charity' ? "Selected charity : " : "Change your charity";
    return (
    <>
        <p className={`normal italic ${styles.heading_txt}`}>Your impact</p>
        <p className={`large light ${styles.subhead_txt}`}>Choose a cause partner</p>
        <p className={`small ${styles.donate_txt}`}>20% of the purchase price for your order will be donated to the charity you choose below.</p>    
    
        <CharityDropdown />     
        
        <div className={`${styles.checkout_btn_div}`}>
          <button className={`btn-primary ${styles.checkout_btn}`} onClick={(e) => popupCloseHandler(false)}>
            <span>Close</span>
          </button>
        </div>
    </>
    )
}